import React from 'react'
import Topheader from '../Topheader/Topheader'
import WhatsAppWidget from '../WhatsAppWidget'
import Footer from '../Footer/Footer'
import { Container, Box } from '@mui/material'
import classes from './MainTemplate.module.css'

const MainTemplate = (props) => {
    return (
        <>
            <Topheader SessionID={props.SessionID} />
            <WhatsAppWidget text={'Reenrol Support'}/>
            <Container maxWidth="xl" className={`${classes.contentContainer}`}>
                <Box className={`${classes.tableContent}`}>
                    {props.content}
                </Box>
                <Footer college={props.college} />
            </Container>
        </>
    )
}

export default MainTemplate
